import $ from 'jquery'
import * as bootbox from 'bootbox'
import { track } from '@/analytics/trackAsync'
import { lowerCase } from 'lodash-es'

export interface DetailsModalScriptOptions {
  title: string
  message: string
}

export const init = function (
  elementSelector: string,
  elementName: string,
  options: DetailsModalScriptOptions,
  clickAnalyticsCategory: string
): void {
  $(`${elementSelector} .${elementName}__details-icon`).on(
    'click',
    function () {
      bootbox.dialog({
        title: options.title,
        message: options.message,
        className: `${elementName}__details-modal modal--full-screen-xs`,
        onEscape: true,
        backdrop: true
      })
      // TODO: If a significant number of people click, get marketing to ID these
      //   and implement Google Analytics Enhanced Ecommerce promotion tracking:
      //   https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-promos
      track(
        `Clicked ${lowerCase(elementName)} details icon`,
        {
          category: clickAnalyticsCategory,
          label: location.pathname
        },
        {
          integrations: {
            woopra: true
          }
        }
      )
    }
  )
}
